import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { isSectionLoading } from '../../../selectors/sections';
import { AppState } from '../../../../types/store';
import { Props } from './SubscriptionsSection';
import { getSectionModuleDataByModuleType } from '../../../selectors/modules';
import { ModuleType } from '../../../../types/modules';

type StateProps = Pick<
  Props,
  'profileOwnerUser' | 'isOwner' | 'hasTiers' | 'isSectionLoading'
>;
type DispatchProps = Pick<Props, 'openTierModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const { tiers = [] } = getSectionModuleDataByModuleType(
    state,
    'subscriptions',
    ModuleType.TIERS
  );
  return {
    isOwner: isCurrentUserProfileOwner(state),
    hasTiers: tiers.length > 0,
    isSectionLoading: isSectionLoading(state),
    profileOwnerUser: getProfileOwnerUser(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  openTierModal: () =>
    modalActions.pushModal(ModalType.TIER_EDIT, {
      wrapInModal: false,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps);
